
export const defaultErrorDisplayText = {
    errorLabelText: 'Error',
    timeoutHeaderText: 'Se acabó el tiempo',
    timeoutMessageText:
      "La cara no encajó dentro del óvalo en el límite de tiempo. Inténtelo de nuevo y llene completamente el óvalo con la cara.",
    faceDistanceHeaderText: 'Movimiento hacia adelante detectado',
    faceDistanceMessageText: 'Evite acercarse al conectarse.',
    multipleFacesHeaderText: 'Multiples caras detectadas',
    multipleFacesMessageText:
      'Asegúrese de que solo haya una cara frente a la cámara al realizar la conexión.',
    clientHeaderText: 'Error en cliente',
    clientMessageText: 'La verificación falló debido a un problema del cliente',
    serverHeaderText: 'Problema del servidor',
    serverMessageText: 'No se puede completar la verificación debido a un problema con el servidor',
    landscapeHeaderText: 'No se admite la orientación horizontal',
    landscapeMessageText:
      'Gire su dispositivo a orientación vertical.',
    portraitMessageText:
      'Asegúrese de que su dispositivo permanezca en orientación vertical mientras dure la verificación.',
    tryAgainText: 'Intentar de nuevo',
  };

export const defaultLivenessDisplayText = {
    cameraMinSpecificationsHeadingText:
        'Camera does not meet minimum specifications',
    cameraMinSpecificationsMessageText:
        'Camera must support at least 320*240 resolution and 15 frames per second.',
    cameraNotFoundHeadingText: 'Camera is not accessible.',
    cameraNotFoundMessageText:
        'Check that a camera is connected and there is not another application using the camera. You may have to go into settings to grant camera permissions and close out all instances of your browser and retry.',
    a11yVideoLabelText: 'Webcam for liveness check',
    cancelLivenessCheckText: 'Cancel Liveness check',
    goodFitCaptionText: 'Good fit',
    goodFitAltText:
        "Ilustration of a person's face, perfectly fitting inside of an oval.",
    hintCenterFaceText: 'Verificación de rostro',
    hintCenterFaceInstructionText:
        'Instruction: Before starting the check, make sure your camera is at the center top of your screen and center your face to the camera. When the check starts an oval will show up in the center. You will be prompted to move forward into the oval and then prompted to hold still. After holding still for a few seconds, you should hear check complete.',
    hintFaceOffCenterText:
        'Face is not in the oval, center your face to the camera.',
    hintMoveFaceFrontOfCameraText: 'Coloca el rostro frente a la camara',
    hintTooManyFacesText: 'Ensure only one face is in front of camera',
    hintFaceDetectedText: 'Face detected',
    hintCanNotIdentifyText: 'Coloca el rostro frente a la camara',
    hintTooCloseText: 'Retroceder',
    hintTooFarText: 'Muévete más cerca',
    hintConnectingText: 'Conectando...',
    hintVerifyingText: 'Mantén el rostro en posición',
    hintCheckCompleteText: 'Verificación completa',
    hintIlluminationTooBrightText: 'Move to dimmer area',
    hintIlluminationTooDarkText: 'Move to brighter area',
    hintIlluminationNormalText: 'Lighting conditions normal',
    hintHoldFaceForFreshnessText: 'Mantén el rostro en posición',
    hintMatchIndicatorText: '50% completed. Keep moving closer.',
    photosensitivityWarningBodyText:
        'This check flashes different colors. Use caution if you are photosensitive.',
    photosensitivityWarningHeadingText: 'Photosensitivity warning',
    photosensitivityWarningInfoText:
        'Some people may experience epileptic seizures when exposed to colored lights. Use caution if you, or anyone in your family, have an epileptic condition.',
    photosensitivityWarningLabelText: 'More information about photosensitivity',
    photosensitivyWarningBodyText:
        'This check flashes different colors. Use caution if you are photosensitive.',
    photosensitivyWarningHeadingText: 'Photosensitivity warning',
    photosensitivyWarningInfoText:
        'Some people may experience epileptic seizures when exposed to colored lights. Use caution if you, or anyone in your family, have an epileptic condition.',
    photosensitivyWarningLabelText: 'More information about photosensitivity',
    retryCameraPermissionsText: 'Reintentar',
    recordingIndicatorText: '',
    startScreenBeginCheckText: 'Comenzar a verificar',
    tooFarCaptionText: 'Muy lejos',
    tooFarAltText:
        "Illustration of a person's face inside of an oval; there is a gap between the perimeter of the face and the boundaries of the oval.",
    waitingCameraPermissionText: 'Esperando los permisos de la camara',
    ...defaultErrorDisplayText,
};

